<template>
	<div>
		<div class="x-stat">
			<a-row :gutter="24">
				<a-col :span="4">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
				<a-col :span="4">
					<a-statistic title="金额(元)" :value="totalCnyYuan" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="商品类型">
								<a-select v-model="queryParams.productType" allowClear placeholder="请选择" style="width: 100%">
									<a-select-option v-for="opt in productTypeOptions" :key="opt.value" :value="opt.value">
										{{ opt.label }}
									</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="支付方式">
								<a-select v-model="queryParams.payType" allowClear placeholder="请选择" style="width: 100%">
									<a-select-option value="ALIPAY">支付宝</a-select-option>
									<a-select-option value="WECHAT">微信</a-select-option>
									<a-select-option value="SCORE">积分</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="货币">
								<a-select v-model="queryParams.currency" allowClear placeholder="请选择" style="width: 100%">
									<a-select-option value="CNY">人民币</a-select-option>
									<a-select-option value="SCORE">积分</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="支付状态">
								<a-select v-model="queryParams.payStatus" allowClear placeholder="请选择" style="width: 100%">
									<a-select-option value="WAIT">待处理</a-select-option>
									<a-select-option value="PAID">已支付</a-select-option>
									<a-select-option value="FAILD">支付失败</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="订单状态">
								<a-select v-model="queryParams.isCompleted" allowClear placeholder="请选择" style="width: 100%">
									<a-select-option value="Y">已完成</a-select-option>
									<a-select-option value="N">未完成</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :span="4">
								<a-form-item label="商品">
									<a-input v-model="queryParams.product" placeholder="商品ID" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="用户">
									<a-input v-model="queryParams.user" placeholder="ID/昵称" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="订单号">
									<a-input v-model="queryParams.orderId" placeholder="订单号" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="回调状态">
									<a-select v-model="queryParams.isCallback" allowClear placeholder="请选择" style="width: 100%">
										<a-select-option value="Y">已回调</a-select-option>
										<a-select-option value="N">未回调</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :md="8">
								<a-form-item label="时间">
									<a-range-picker v-model="createTime" style="width: 100%" @change="onCreateTime" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span
								class="x-filter-submit-box"
								:style="advanced && { float: 'right', overflow: 'hidden' } || {}"
							>
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left: 8px" @click="rest">重置</a-button>
								<a style="margin-left: 8px" @click="toggleAdvanced">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table
				:rowKey="(record) => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<template slot="user" slot-scope="record">
					<div v-if="record.userId" class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.avatarUrl || ''" width="48" height="48" alt="" @click="openUserDetail(record.userId)" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.nickname }}</span>
							</p>
							<p class="row">
								<span v-if="record.sex === 'MALE'" class="user-right-detail">男</span>
								<span v-else-if="record.sex === 'FEMALE'" class="user-right-detail">女</span>
								<span v-if="record.age != null && record.age !== ''" class="user-right-detail">{{ record.age }}岁</span>
								<span class="user-right-detail">{{ record.province }}{{ record.city }}</span>
							</p>
						</div>
					</div>
					<span v-else class="muted">-</span>
				</template>

				<template slot="productOrder" slot-scope="record">
					<div class="stack">
						<p class="main">{{ (record.product && record.product.digest) || '-' }}</p>
						<p class="sub">{{ record.orderId }}</p>
					</div>
				</template>

				<template slot="payType" slot-scope="record">
					<span>{{ payTypeLabel(record.payType) }}</span>
				</template>

				<template slot="payAmount" slot-scope="record">
					<span>{{ record.payAmountDisplay }}</span>
				</template>

				<template slot="payStatus" slot-scope="record">
					<div class="stack">
						<span v-if="record.payStatus == 'PAID'" class="ok">已支付</span>
						<span v-else-if="record.payStatus == 'WAIT'" class="warn">待处理</span>
						<span v-else class="fail">支付失败</span>
						<template v-if="record.payStatus === 'PAID'">
							<p v-if="record.tradeId" class="sub">流水：{{ record.tradeId }}</p>
							<p v-if="record.payTimeFmt" class="sub">{{ record.payTimeFmt }}</p>
						</template>
					</div>
				</template>

				<template slot="callbackStatus" slot-scope="record">
					<div class="stack">
						<span v-if="record.isCallback === 'Y'" class="ok">已回调</span>
						<span v-else class="warn">未回调</span>
						<p v-if="record.isCallback === 'Y' && record.callbackTimeFmt" class="sub">{{ record.callbackTimeFmt }}</p>
					</div>
				</template>

				<template slot="orderStatus" slot-scope="record">
					<div class="stack">
						<span v-if="record.isCompleted === 'Y'" class="ok">已完成</span>
						<span v-else class="warn">未完成</span>
						<p v-if="record.isCompleted === 'Y' && record.completedTimeFmt" class="sub">{{ record.completedTimeFmt }}</p>
					</div>
				</template>

				<template slot="action" slot-scope="record">
					<a @click="openDetail(record)">商品详情</a>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination
					v-model="pageIndex"
					:pageSize="pageSize"
					:total="totalRow"
					:hideOnSinglePage="true"
					show-less-items
					@change="pageChange"
				/>
			</div>
		</a-card>

		<a-drawer title="商品详情" placement="right" :width="560" :visible="detailVisible" :destroyOnClose="true" @close="closeDetail">
			<template v-if="detailRecord">
				<a-descriptions title="商品" :column="1" bordered size="small" style="margin-bottom: 16px">
					<a-descriptions-item label="商品ID">{{ (detailRecord.product && detailRecord.product.id) || '-' }}</a-descriptions-item>
					<a-descriptions-item label="类型">{{ productTypeLabel((detailRecord.product && detailRecord.product.type) || '') }}</a-descriptions-item>
					<a-descriptions-item label="名称">{{ (detailRecord.product && detailRecord.product.name) || '-' }}</a-descriptions-item>
					<a-descriptions-item label="摘要">{{ (detailRecord.product && detailRecord.product.digest) || '-' }}</a-descriptions-item>
				</a-descriptions>
				<a-descriptions title="订单" :column="1" bordered size="small">
					<a-descriptions-item label="订单主键">{{ detailRecord.id }}</a-descriptions-item>
					<a-descriptions-item label="订单号">{{ detailRecord.orderId }}</a-descriptions-item>
					<a-descriptions-item label="交易流水">{{ detailRecord.tradeId || '-' }}</a-descriptions-item>
					<a-descriptions-item label="用户ID">{{ detailRecord.userId }}</a-descriptions-item>
					<a-descriptions-item label="货币">{{ detailRecord.currency }}</a-descriptions-item>
					<a-descriptions-item label="支付方式">{{ payTypeLabel(detailRecord.payType) }}</a-descriptions-item>
					<a-descriptions-item label="支付金额">{{ detailRecord.payAmountDisplay }}</a-descriptions-item>
					<a-descriptions-item label="关联">{{ detailRecord.refType || '-' }} / {{ detailRecord.refId }}</a-descriptions-item>
					<a-descriptions-item label="备注">{{ detailRecord.remark || '-' }}</a-descriptions-item>
					<a-descriptions-item label="创建时间">{{ detailRecord.created }}</a-descriptions-item>
				</a-descriptions>
			</template>
		</a-drawer>
		<user-detail-drawer ref="userDetailDrawer" />
	</div>
</template>

<script>
import moment from 'moment';
import UserDetailDrawer from '@/components/UserDetailDrawer.vue';
import { productOrderList } from '@/api/op/productOrder';

const productTypeOptions = [
	{ value: 'RECHARGE_GOLD', label: '充值金币' },
	{ value: 'RECHARGE_VIP', label: '充值会员' },
	{ value: 'EXCHANGE_GOLD', label: '兑换金币' },
	{ value: 'EXCHANGE_VIP', label: '兑换会员' },
	{ value: 'EXCHANGE_CASH', label: '兑换现金' },
];

const tableColumns = [
	{ title: '#', dataIndex: 'id', width: 70 },
	{ title: '用户', scopedSlots: { customRender: 'user' }, width: 220 },
	{ title: '商品&订单', scopedSlots: { customRender: 'productOrder' }, width: 220 },
	{ title: '支付方式', scopedSlots: { customRender: 'payType' }, width: 90 },
	{ title: '支付金额', scopedSlots: { customRender: 'payAmount' }, width: 110 },
	{ title: '支付状态', scopedSlots: { customRender: 'payStatus' }, width: 160 },
	{ title: '回调状态', scopedSlots: { customRender: 'callbackStatus' }, width: 140 },
	{ title: '订单状态', scopedSlots: { customRender: 'orderStatus' }, width: 140 },
	{ title: '创建时间', dataIndex: 'created', width: 170 },
	{ title: '操作', scopedSlots: { customRender: 'action' }, width: 100 },
];

export default {
	components: {
		UserDetailDrawer,
	},
	data() {
		return {
			advanced: false,
			queryParams: {},
			totalRow: 0,
			totalCnyYuan: 0,
			tableColumns,
			tableData: [],
			tableLoading: false,
			pageSize: 20,
			pageIndex: 1,
			createTime: [],
			detailVisible: false,
			detailRecord: null,
			productTypeOptions,
		};
	},
	created() {
		this.fetchTableData();
	},
	methods: {
		productTypeLabel(v) {
			const o = this.productTypeOptions.find((x) => x.value === v);
			return o ? o.label : v || '-';
		},
		payTypeLabel(v) {
			if (v === 'ALIPAY') return '支付宝';
			if (v === 'WECHAT') return '微信';
			if (v === 'SCORE') return '积分';
			return v || '-';
		},
		fetchTableData() {
			this.tableLoading = true;
			this.queryParams.pageSize = this.pageSize;
			this.queryParams.page = this.pageIndex;
			productOrderList(this.queryParams)
				.then((res) => {
					this.totalRow = res.data.totalRow;
					this.totalCnyYuan = res.data.totalCnyYuan;
					this.tableData = res.data.recordList || [];
				})
				.finally(() => {
					this.tableLoading = false;
				});
		},
		pageChange(current) {
			this.pageIndex = current;
			this.fetchTableData();
		},
		toggleAdvanced() {
			this.advanced = !this.advanced;
		},
		onCreateTime(values) {
			this.queryParams.startCreateTime = moment(values[0]).unix();
			this.queryParams.endCreateTime = moment(values[1]).unix();
		},
		rest() {
			this.createTime = [];
			this.queryParams = {};
			this.pageIndex = 1;
			this.fetchTableData();
		},
		openUserDetail(id) {
			if (this.$refs.userDetailDrawer) {
				this.$refs.userDetailDrawer.open(id);
			}
		},
		openDetail(record) {
			this.detailRecord = record;
			this.detailVisible = true;
		},
		closeDetail() {
			this.detailVisible = false;
			this.detailRecord = null;
		},
	},
};
</script>

<style lang="less" scoped>
.user {
	display: flex;
	flex-direction: row;

	.user-left {
		display: flex;
		flex-direction: column;
		margin-right: 8px;
		text-align: center;

		.cover-img {
			border-radius: 4px;
			object-fit: cover;
			cursor: pointer;
		}
	}

	.user-right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		p.first {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			align-items: center;
			margin: 0;

			.nickname {
				color: #686868;
				font-weight: bold;
			}
		}

		p.row {
			font-size: 12px;
			color: #acacac;
			margin: 0;
		}

		.user-right-detail {
			margin-right: 5px;
		}
	}
}

.stack {
	p {
		margin: 0;
	}
	.main {
		font-weight: 500;
	}
	.sub {
		font-size: 12px;
		color: #8c8c8c;
		margin-top: 4px;
	}
}

.ok {
	color: #52c41a;
}

.warn {
	color: #fa8c16;
}

.fail {
	color:#f5222d;
}

.muted {
	color: #bfbfbf;
	font-size: 12px;
}
</style>
